import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getSidebarItem = createSelector(
  (state: RootState) => state.sidebarItem,
  sidebarItem => sidebarItem,
)
